// Analytics helper — pushes events into window.dataLayer so GTM (GTM-MG9Z3BS)
// can forward them to GA4 (property G-PKT2YYSCQ0) and any other configured tags.
//
// SINGLE SOURCE OF TRUTH for all analytics events on this site.
// Do NOT push directly to window.dataLayer elsewhere — always go through here.
//
// GTM setup expectation:
//   - GA4 Configuration tag: Measurement ID = G-PKT2YYSCQ0
//   - "Send a page view event when this configuration loads" = TRUE (default)
//     ⇒ initial page_view fires automatically on first load.
//   - Additionally, a GA4 Event tag listens to Custom Event = "page_view"
//     to catch client-side route changes in this React SPA.
//   - Custom Event triggers exist for: contact_form_submit, form_submit,
//     welcome_popup_shown, welcome_popup_accept, welcome_popup_dismiss,
//     welcome_popup_code_copy, spanish_badge_shown, spanish_badge_accept,
//     spanish_badge_dismiss, rewards_click, order_online_click,
//     directions_click, language_change, promo_code_copy.

/**
 * Fire a generic dataLayer event. GTM listens on Custom Event triggers.
 * @param {string} name — event name (snake_case, matches GTM trigger)
 * @param {object} params — optional additional properties
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...params });
  } catch (e) { /* ignore */ }
}

/**
 * Fire a page_view event for SPA route changes.
 * NOTE: the initial page load is handled automatically by GTM's GA4 Config tag
 * (send_page_view = true). Only call this on SUBSEQUENT route changes to avoid
 * duplicating the first page_view.
 */
export function pageView({ path, title, location }) {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "page_view",
      page_path: path,
      page_title: title,
      page_location: location,
    });
  } catch (e) { /* ignore */ }
}
